import React from 'react';
import ContactForm from '../../Shared/ContactForm/ContactForm';
import './Contact.css';

const Contact = () => {
    return (
        <section className="contact-section" id="contact-form">
            <div className="contact-form-wrapper">
                <div className="contact-form-head" style={{ textAlign: 'center' }}>
                    <h2 className="jsectionHead">Contact me</h2>
                </div>
                <ContactForm />
            </div>
        </section>
    )
};

export default Contact;